export const SKILLS = ['Salesforce Development and Administraton', 'React', 'JavaScript', 'Nodejs', 'Express', 'SQL', 'Redux', 'Java'];

export const ABOUT = `Currently working as a Salesforce Developer for Capgemini, India. 
    Also works as a freelance React Developer.
    Philatelist by Hobby. Loves to listen to music and explore new places.`;

export const LINK = 'https://drive.google.com/file/d/1zI8NofxG5LZUibAS56xxIpQjOXWMfRM_/view?usp=sharing';

export const EXP = [
    {
        title: 'Senior Analyst at Capgemini, India',
        period: 'September 2020 - Present',
        location: 'Mumbai, Maharastra',
        tasks: `Undergone a 3 month intensive training in the domain of 
                Salesforce.com Administration and Development. Built
                Certification Management System using tools provided by
                Salesforce along with the user interface developed using
                Lightning Web Framework of Salesforce.`
    },
    {
        title: 'Intern at Capgemini, India',
        period: 'January - March 2020',
        location: 'Pune, Maharastra',
        tasks: `Undergone a 3 month intensive training in the domain of 
                Salesforce.com Administration and Development. Built
                Certification Management System using tools provided by
                Salesforce along with the user interface developed using
                Lightning Web Framework of Salesforce.`
    }
]
